import { ComponentFileType, ComponentFileTypes } from './ComponentFileType';

export enum CollateralOnlyCategory {
    BROCHURE = 'brochure',
    ONE_PAGER = 'onePager',
    CASE_STUDY = 'caseStudy',
    TESTIMONIAL = 'testimonial',
    PRESS = 'press',
}

export type CollateralCategory = ComponentFileType | CollateralOnlyCategory;

const PRODUCT_ONLY_FILE_TYPES = [
    ComponentFileType.CHARACTERISTICS,
    ComponentFileType.DYNAMIC_CHARACTERISTICS,
    ComponentFileType.OUTPUT_IMPEDANCE_CHARACTERISTICS,
];

const fileTypeOption = (type: ComponentFileType) => ComponentFileTypes.options.find(({ value }) => value === type)!;

export const CollateralCategoryOptions: { value: CollateralCategory; label: string }[] = [
    fileTypeOption(ComponentFileType.DATASHEET),
    { value: CollateralOnlyCategory.BROCHURE, label: 'Brochure' },
    { value: CollateralOnlyCategory.ONE_PAGER, label: 'One-Pager' },
    { value: CollateralOnlyCategory.CASE_STUDY, label: 'Case Study' },
    { value: CollateralOnlyCategory.TESTIMONIAL, label: 'Testimonial' },
    { value: CollateralOnlyCategory.PRESS, label: 'Press and Awards' },
    ...ComponentFileTypes.options.filter(
        ({ value }) =>
            value !== ComponentFileType.DATASHEET &&
            value !== ComponentFileType.OTHER &&
            !PRODUCT_ONLY_FILE_TYPES.includes(value),
    ),
    fileTypeOption(ComponentFileType.OTHER),
];
